import Qs from "qs";
import axios from "axios";
import cookie from "js-cookie";

import * as constants from "../constants/constant";
import {
  isEmpty,
  getAppHash,
  getPlatform,
  getDeviceInfo,
} from "../helpers/helpers";

const request = axios.create();

const ISSERVER = typeof window === "undefined";
let deviceId = null;
if (!ISSERVER) {
  const key = `${constants.CONFIG_SERVER.NEXT_PUBLIC_APP_ID}_v2021-05-03`;
  deviceId = `${new Date().valueOf()}-${Math.random()}`;
  const value = localStorage.getItem(key);
  if (value === null) {
    localStorage.setItem(key, deviceId);
  } else {
    deviceId = value;
  }
}

request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => {
    if (response?.data?.code === 401) {
      cookie.remove(constants.TOKEN);
      window.location.href = "/";
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      cookie.remove(constants.TOKEN);
      window.location.href = "/";
    }
    return Promise.reject(error.response || { data: {} });
  }
);

const getBaseUrl = (severVice = "") => {
  switch (severVice) {
    case constants.AFF_SERVICE:
      return `${constants.CONFIG_SERVER.NEXT_PUBLIC_DOMAIN_BACKEND_CORE}`;
    case constants.AFF_ASSES_UPLOAD:
      return `${constants.CONFIG_SERVER.NEXT_PUBLIC_DOMAIN_BACKEND_CORE_ASSES_UPLOAD}`;
    default:
      return constants.CONFIG_SERVER.NEXT_PUBLIC_DOMAIN_GATE;
  }
};

const api = (options = {}) => {
  if (!options.noAuthentication) {
    if (
      !isEmpty(cookie.get(constants.TOKEN)) &&
      options.severVice !== constants.AFF_ASSES_UPLOAD
    ) {
      options.headers = {
        ...options.headers,
        // eslint-disable-next-line
        ["login_token"]: `${cookie.get(constants.TOKEN)}`,
      };
    }
  }
  options.headers = {
    ...options.headers,
    caId: 17,
    deviceId,
    deviceInfo: getDeviceInfo(),
    lang: "vi",
    platform: getPlatform(),
    appId: constants.CONFIG_SERVER.NEXT_PUBLIC_APP_ID,
    appHash: getAppHash(),
    version: constants.VERSION_HOTEL_SERVICE,
  };
  return request({
    baseURL: getBaseUrl(options.severVice),
    ...options,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: "repeat" }),
    headers: {
      ...options.headers,
    },
  });
};

export default api;
